export const weights = {
  light: 300,
  regular: 400,
  bold: 800,
}
